const stateObj = {
  rwOptions: null,
};

const mutations = {
  setOptions(state, rwOptions) {
    // eslint-disable-next-line no-param-reassign
    state.rwOptions = rwOptions;
  },
};

const actions = {
  loadOptions(context) {
    try {
      context.commit('setOptions', window.rwOptions);
    } catch {
      // TODO: What should we do?
    }
  },
};

const getters = {
  captchaSiteKey: (state) => state?.rwOptions?.CAPTCHA_SITE_KEY ?? null,
  baseFolder: (state) => state?.rwOptions?.BASE_FOLDER ?? null,
  riaId: (state) => state?.rwOptions?.RIA_ID ?? null,
  appEnv: (state) => state?.rwOptions?.APP_ENV ?? null,
  s3BaseUrl: (state) => state?.rwOptions?.S3_BASE_URL ?? null,
  isUnderMaintenance: (state) => state?.rwOptions?.IS_UNDER_MAINTENANCE ?? null,
  allowStaticSso: (state) => state?.rwOptions?.ALLOW_STATIC_SSO ?? null,
  advisor: (state) => state?.rwOptions?.ADVISOR ?? null,
  cms: (state) => state?.rwOptions?.CMS ?? null,
  region: (state) => state?.rwOptions?.REGION ?? null,
  userpoolId: (state) => state?.rwOptions?.USERPOOL_ID ?? null,
  clientId: (state) => state?.rwOptions?.CLIENT_ID ?? null,
  authDomain: (state) => state?.rwOptions?.AUTH_DOMAIN ?? null,
  authRedirectSignInUri: (state) => state?.rwOptions?.AUTH_REDIRECT_SIGN_IN_URI ?? null,
  rolloverEnabled: (state) => state?.rwOptions?.ROLLOVER_ENABLED ?? null,
  maintenanceMsg: (state) => state?.rwOptions?.MAINTENANCE_MSG ?? null,
  pfgEnterpriseId: (state) => state?.rwOptions?.PFG_ENTERPRISE_ID ?? null,
};

export default {
  namespaced: true,
  state: stateObj,
  mutations,
  actions,
  getters,
};
